<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Supplier Account',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Supplier Account
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <!-- <PIconBtn icon="mdi-sign-real-estate" tooltip="Statement" @click="navigateToStatement"></PIconBtn> -->
                            <PIconBtn icon="mdi-pencil" tooltip="Save" @click="handleEdit" v-if="hasPermission(perm.supplier_account.update)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierAccount :value="data" v-if="!loading"/>
                </v-sheet>
            </v-col>
        </v-row>
        <LoadingOverlay v-model="loading"/>
    </v-container>
   
</template>

<script>
import permissions from './../../data/permissions';
import LoadingOverlay from './../../components/common/LoadingOverlay.vue';
import SupplierAccount from "./../../components/purchase/SupplierAccount.vue"
import PIconBtn from '../../components/common/PIconBtn.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "SupplierAccountDispalyView",
    components: {
        PIconBtn,
        SupplierAccount,
        LoadingOverlay
    },
    data() {
        return {
            id: null,
            data: null,
            loading: true,
            perm: permissions
        }
    },
    computed: {
        supplier() {
            return this.data.supplier
        },
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/supplierAccount/findByID",
            snackbar: "ui/snackbar/show"
        }),
        handleEdit() {
            this.$router.push({ name: "SupplierAccountEdit" })
        },
        fetchSupplierAccount() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.data = response.data;
                // this.data.id = response.data.id
                // this.data.supplier = response.data.supplier ? response.data.supplier.name : null
                // this.data.name = response.data.name
                // this.data.currency = response.data.currency ? response.data.currency.name : null
                // this.data.ladger_payable = response.data.ladger_payable ? response.data.ladger_payable.name : null
                // this.data.ladger_prepaid = response.data.ladger_prepaid ? response.data.ladger_prepaid.name : null
            }).catch((error) => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar( {text: message, color: "error"} )
            }).finally(() => {
                this.loading = false 
            })
        },
        navigateToStatement() {
            this.$router.push({ name: "SupplierAccountStatementView", query : { supplierId: this.supplier.id,  accountId: this.data.id }})
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.fetchSupplierAccount()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.fetchSupplierAccount();
        next()
    }
}
</script>

<style>

</style>